// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import { StyleSheet, Text, View } from '@react-pdf/renderer'

const styles = StyleSheet.create({
  footerText: {
    color: '#141414',
    textAlign: 'left',
    fontFamily: 'Helvetica',
    fontSize: 10,
    fontStyle: 'normal',
    right: 24,
  },
  pageNumberText: {
    color: '#141414',
    fontFamily: 'Helvetica',
    fontSize: 10,
    fontStyle: 'normal',
    fontWeight: '400',
    textAlign: 'right',
    marginTop: 8,
  },
  footerBlock: {
    position: 'absolute',
    bottom: 32,
    right: 32,
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
})
const PatientChartsPrintedFriendlyFooter = () => (
  <View break={false} style={styles.footerBlock}>
    <Text style={styles.footerText}>
      Disclaimer: If you have questions about a medical condition or instructions, always ask your healthcare
      professional.
    </Text>
    <Text
      style={styles.pageNumberText}
      render={({ pageNumber, totalPages }) => `Patient records page ${pageNumber} of ${totalPages}`}
      fixed
    />
  </View>
)
export default PatientChartsPrintedFriendlyFooter
